import { Pipe, PipeTransform } from '@angular/core';
import linkifyHtml from 'src/shared/util/linkify';

@Pipe({
    name: 'parseText',
    standalone: false
})
export class ParseTextPipe implements PipeTransform {
  transform(value: string, checkLineBreaks: boolean, linkify: boolean): string {
    if (!value) {
      return '';
    }
    let transformedText = value;

    if(checkLineBreaks) {
      transformedText = transformedText.replace(/(↵|\n|\u21b5)/g, '<br/>');
    }

    if(linkify) {
      transformedText = linkifyHtml(transformedText, {target: '_blank'});
    }

    return transformedText;
  }
}
